import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AppService from "~/services/AppService";
import LegacyApiService from "~/services/LegacyApiService";
import OnboardingLayout from "./OnboardingLayout";

export const MagicLinkLoginPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    const intent = searchParams.get("intent");
    if (!intent) {
      navigate("/projects");
    }
    LegacyApiService.post("/user-session", {
      intent: intent,
      remember: true,
    })
      .then(async () => {
        const initial = await AppService.getInitial();
        //remove when checked
        if (
          initial?.settings?.on_demand &&
          (initial?.settings?.show_set_password || initial?.settings?.show_sample_projects_wizard_step)
        ) {
          return navigate("/onboarding");
        }

        navigate("/projects");
      })
      .catch(() => {
        return navigate("/projects");
      });
  }, [navigate, searchParams]);

  return <OnboardingLayout />;
};

export default MagicLinkLoginPage;
